module.exports = __webpack_public_path__ + "img/avatar4.6ec06133.png";